export const imageGalleryInstructions = 'Hover over image to zoom in';
export const hoveredImageGalleryInstructions = 'Click image to open expanded view';
